export function transformEmailOptions(dataToTransform) {
    if (dataToTransform && dataToTransform.emailOptions) {
        const transformedData = {
            ...dataToTransform,
            emailOptions: {
                ...dataToTransform.emailOptions,
                recipients: dataToTransform.emailOptions ? dataToTransform.emailOptions.recipients.join(' ') : '',
                recipientsCc: dataToTransform.emailOptions ? dataToTransform.emailOptions.recipientsCc.join(' ') : '',
                recipientsBcc: dataToTransform.emailOptions ? dataToTransform.emailOptions.recipientsBcc.join(' ') : '',
            },
        };

        return transformedData;
    }

    return dataToTransform;
}
